import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_DELIVERY_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * Renders the local delivery fee line item (Rent Gear — local delivery).
 * Uses 'line-item/delivery-fee' so it shows "Delivery Fee", not "Shipping".
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems
 * @param {intlShape} props.intl
 * @returns {JSX.Element|null}
 */
const LineItemDeliveryFeeMaybe = props => {
  const { lineItems, intl } = props;

  const deliveryFeeLineItem = lineItems.find(
    item => item.code === LINE_ITEM_DELIVERY_FEE && !item.reversal
  );

  if (!deliveryFeeLineItem) return null;

  const amount = deliveryFeeLineItem.lineTotal?.amount ?? 0;
  const valueDisplay =
    amount === 0
      ? intl.formatMessage({ id: 'OrderBreakdown.pickupFree' })
      : formatMoney(intl, deliveryFeeLineItem.lineTotal);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.deliveryFee" />
      </span>
      <span className={css.itemValue}>{valueDisplay}</span>
    </div>
  );
};

export default LineItemDeliveryFeeMaybe;
